<template>
  <div>
    <v-img
      height="100vh"
      src="/imagenes/credito_mipyme.webp"
      gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)"
    >
      <v-layout column align-center justify-center fill-height mx-12>
        <v-flex xs1 sm1 md1 lg1>
          <h1
            :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : '']"
            class="font-weight-bold white--text text-center"
          >
            Bolsa de trabajo
          </h1>
        </v-flex>
      </v-layout>
    </v-img>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="4"
          class="mt-5"
          v-for="item in items"
          :key="item.id"
        >
          <v-card height="100%" class="d-flex flex-column">
            <v-card-title class="font-weight-bold" style="flex: 2">{{
              item.puesto
            }}</v-card-title>
            <v-card-text style="flex: 8">
              <h3 class="pb-2 my-0 font-weight-bold overline primary--text">
                Datos del contacto
              </h3>
              <h3 class="pb-2 my-0 font-weight-bold">{{ item.contacto }}</h3>
              <h4 class="py-1 my-0">{{ item.contacto_tel | phone }}</h4>
              <h4 class="py-1 my-0">{{ item.contacto_email }}</h4>
              <h3 class="py-2 my-0 font-weight-bold overline primary--text">
                Requisitos
              </h3>
              <h3 class="pb-2 my-0 font-weight-bold">{{ item.requisitos }}</h3>
              <h3 class="pt-3 overline my-0 font-weight-bold">
                Sueldo tentativo
              </h3>
              <h2 class="pt-3 pb-2 my-0 font-weight-bold success--text">
                {{ item.sueldo | currency }}
              </h2>
            </v-card-text>
            <v-card-actions
              class="d-flex justify-start align-items-end pl-5 pb-5"
              style="flex: 1"
            >
              <v-btn
                class="font-weight-bold"
                color="primary"
                @click="goToPostulate(item)"
                >Postularme</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="postulateDialog"
      persistent
      max-width="500"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title class="font-weight-bold primary white--text"
          >Nueva vacante</v-card-title
        >
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-text-field
                outlined
                v-model="job.contacto"
                hide-details
                label="Nombre completo"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                v-model="job.contacto_tel"
                hide-details
                maxlength="14"
                v-mask="'(###) ###-####'"
                label="Teléfono de contacto"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-file-input
                outlined
                v-model="job.file"
                accept="pdf/*"
                label="Curriculum Vitae"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end align-center pr-5 pb-5">
          <v-btn
            class="font-weight-bold"
            text
            color="grey"
            @click="postulateDialog = !postulateDialog"
            >cancelar</v-btn
          >
          <v-btn
            class="font-weight-bold"
            color="primary"
            @click="writeUserData()"
            :loading="isLoading"
            :disabled="isLoading"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style></style>
<script>
import firebase from "firebase";

export default {
  mounted() {
    let self = this;
    firebase
      .database()
      .ref("/")
      .on("value", function(snapshot) {
        self.items = snapshot
          .val()
          .jobs.filter((item) => item.status != "deleted");
        self.id_reference = snapshot.val().id;
        /* eslint-disable no-console */
        console.log(snapshot.val());
        console.log(self.id_reference);

        /* eslint-disable no-console */
      });
  },
  data() {
    return {
      user: {},
      postulateDialog: false,
      expanded: [],
      id_reference: null,
      job: {
        contacto: "",
        contacto_tel: "",
        file: null,
      },
      headers: [
        {
          value: "puesto",
          text: "Puesto",
          sortable: true,
        },
        {
          value: "contacto",
          text: "Contacto",
          sortable: true,
        },
        {
          value: "sueldo",
          text: "Propuesta salarial",
          sortable: true,
        },
        { text: "Acciones", value: "actions" },
      ],
      items: [],
      selected: {},
      isLoading: false,
    };
  },
  methods: {
    goToPostulate(item) {
      this.selected = item;
      this.postulateDialog = !this.postulateDialog;
    },
    writeUserData() {
      let self = this;
      let database = firebase.database();
      var storage = firebase.storage();
      var storageRef = storage.ref();
      let ref = this.makeid(25);
      self.isLoading = !self.isLoading;
      var imagesRef = storageRef.child(ref);
      var uploadTask = imagesRef.put(this.job.file);
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function(snapshot) {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              break;
          }
        },
        function(error) {
          switch (error.code) {
            case "storage/unauthorized":
              break;
            case "storage/canceled":
              break;
          }
        },
        function() {
          // Upload completed successfully, now we can get the download URL
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            /* eslint-disable no-console */
            console.log("Uploaded a blob or file!");
            console.log("File available at", downloadURL);
            self.job = { ...self.job, url: downloadURL, ref: ref };
            console.log(self.job);
            database
              .ref("/jobs/" + self.selected.id + "/postulados/" + ref)
              .set({
                ...self.job,
              });
            self.job = {
              contacto: "",
              contacto_tel: "",
              file: null,
            };
            self.isLoading = false;
            self.postulateDialog = false;

            /* eslint-disable no-console */
          });
        }
      );
    },
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
  },
};
</script>
